<template>
	<main-container>
		<material-card icon="fas fa-info-circle" :title="$t('systemmessages.table_title')">
			<template slot="filters">
				<v-col cols="12" xs="12" sm="4">
					<v-select hide-details :label="$t('systemmessages.type')" v-bind:items="$appOptions.systemMessagesType()" v-model="systemmessages_options.type" item-text="label" item-value="value" small-chips @change="systemmessages_options.page = 1"></v-select>
				</v-col>
				<v-col cols="12" xs="12" sm="6" md="4">
					<search-box v-model="systemmessages_options.search" nocolor @change="systemmessages_options.page = 1"></search-box>
				</v-col>
			</template>
			<material-table @click-action="showSystemMessage" :headers="systemmessages_headers" :items="systemmessages.data" :options.sync="systemmessages_options" :server-items-length="systemmessages.total" :loading="systemmessages_loading">
				<template v-slot:item.created_at="{ item }">{{ $formatters.formatDateTime(item.created_at) }}</template>
				<template v-slot:item.type="{ item }">{{ $appOptions.systemMessagesType(item.type) }}</template>
			</material-table>
		</material-card>
		<instant-edit v-model="show_systemmessage" :icon="currentSystemMessage.icon" :title="currentSystemMessage.displayedTitle" :color="currentSystemMessage.color">
			<div slot="afterheading" v-if="currentSystemMessage.title">
				<strong>{{ currentSystemMessage.title }}</strong>
			</div>
			<v-divider :class="'my-1 ' + currentSystemMessage.color" style="opacity: 0.42" v-if="currentSystemMessage.title && currentSystemMessage.content"></v-divider>
			<span v-if="currentSystemMessage.content" v-html="currentSystemMessage.content"></span>
		</instant-edit>
	</main-container>
</template>

<script>
export default {
	data: () => ({
		originalsystemmessages_options: null,
		show_systemmessage: false,
		currentSystemMessage: {},
	}),
	computed: {
		systemmessages_headers() {
			let headers = [];
			headers.push({
				text: this.$t("systemmessages.created_at"),
				value: "created_at",
				align: "left",
				sortable: true,
				width: "1%",
			});
			headers.push({
				text: this.$t("systemmessages.type"),
				value: "type",
				align: "left",
				sortable: true,
			});
			headers.push({
				text: this.$t("systemmessages.title"),
				value: "title",
				align: "left",
				sortable: true,
			});
			return headers;
		},
		systemmessages_options: {
			get: function () {
				return this.$store.getters.getSystemMessagesOptions;
			},
			set: function (value) {
				this.$store.commit("setSystemMessagesOptions", value);
			},
		},
		systemmessages() {
			return this.$store.getters.getSystemMessages;
		},
		systemmessages_loading() {
			return this.$store.getters.systemmessages_loading;
		},
	},
	methods: {
		loadSystemMessages() {
			const self = this;
			if (self.$functions.ObjectAreEqual(self.originalsystemmessages_options, self.systemmessages_options) == false) {
				self.originalsystemmessages_options = _.cloneDeep(self.systemmessages_options);
				self.$store.dispatch("fetchSystemMessages");
			}
		},
		showSystemMessage(item) {
			let cloned = _.cloneDeep(item);
			if (cloned.type == "warning") {
				cloned.color = "warning";
				cloned.icon = "fas fa-triangle-exclamation";
			} else {
				cloned.color = "primary";
				cloned.icon = "fas fa-circle-info";
			}
			cloned.displayedTitle = this.$appOptions.systemMessagesType(cloned.type);
			this.currentSystemMessage = cloned;
			this.show_systemmessage = true;
		},
	},
	watch: {
		systemmessages_options: {
			handler(val) {
				this.loadSystemMessages();
			},
			deep: true,
		},
	},
};
</script>
